import { FC } from "react";
import parse from "html-react-parser";
import { KeyPointList } from "./KeyPoints.styled";

interface Props {
  keypoints: string;
  title: string;
}

const KeyPoints: FC<Props> = ({ keypoints, title }) => {
  if (!keypoints) {
    return null;
  }
  if (keypoints.length === 0) {
    return null;
  }


  return (
    <>
      {title && title}
      <KeyPointList>{parse(keypoints)}</KeyPointList>
    </>
  );
};

export default KeyPoints;
